export default "__VITE_ASSET__CEl3jKGC__"